import {
  ILicenseRequestsListParams,
  LicenseRequestApiActionType,
  LicenseRequestApiDecision,
  LicenseRequestApiStatus,
} from "~/entity/Licenses";

import { ILicenseAdminFilter } from "./licenseManagementUrlParams";

const actionTypeMap: Record<string, LicenseRequestApiActionType> = {
  additional: "ADDITIONAL_REQUEST",
  baseIssue: "BASE_ISSUE",
};

const resolveStatus = (
  filter: ILicenseAdminFilter,
): LicenseRequestApiStatus | undefined => {
  if (filter.decision === "rejected") {
    return "REJECTED";
  }

  if (filter.status === "draft") {
    return "DRAFT";
  }

  if (filter.status === "pendingReview") {
    return "SENT";
  }

  if (filter.status === "decided" && filter.decision === "accepted") {
    return "APPROVED";
  }

  return undefined;
};

const resolveDecision = (
  filter: ILicenseAdminFilter,
): LicenseRequestApiDecision | undefined => {
  if (filter.decision === "accepted") {
    return "ACCEPTED";
  }

  if (filter.decision === "rejected") {
    return "REJECTED";
  }

  if (filter.status === "pendingReview") {
    return "REVIEWING";
  }

  return undefined;
};

export const needsMergedFinalStatuses = (filter: ILicenseAdminFilter) =>
  filter.status === "decided" && !filter.decision;

const toApiDateStart = (date?: string) =>
  date ? `${date}T00:00:00.000Z` : undefined;

const toApiDateEnd = (date?: string) =>
  date ? `${date}T23:59:59.999Z` : undefined;

export const mapLicenseFilterToQuery = (
  page: number,
  count: number,
  filter: ILicenseAdminFilter,
): ILicenseRequestsListParams => ({
  page,
  count,
  dealerId: filter.dealerId ? Number(filter.dealerId) : undefined,
  organizationId: filter.organizationId || undefined,
  inn: filter.inn || undefined,
  branchCode: filter.branchCode || undefined,
  year: filter.year ? Number(filter.year) : undefined,
  actionType: filter.actionType ? actionTypeMap[filter.actionType] : undefined,
  status: resolveStatus(filter),
  decision: resolveDecision(filter),
  createdFrom: toApiDateStart(filter.createdFrom),
  createdTo: toApiDateEnd(filter.createdTo),
  updatedFrom: toApiDateStart(filter.updatedFrom),
  updatedTo: toApiDateEnd(filter.updatedTo),
});
